import { Route, Routes } from 'react-router-dom';
import { PWPMainPage } from './pwp-main.page';

/**
 * Medicare Advantage Personalized Wellness Plan Routes
 */
export const PWPRoutes = () => (
  <Routes>
    <Route index element={<PWPMainPage />} />
    <Route path=":id" element={<PWPMainPage />} />
  </Routes>
);
